
import Vue from 'vue'
import axios from 'axios'
import  { Component } from 'vue-property-decorator'
import { downloadFile } from '../../global/functions/util'
import { TranslationActivity } from '../../global/models'

@Component
export default class DownloadTranslationModal extends Vue {
  activity: TranslationActivity | null = null

  hideStamp = false

  show = false

  downloadTranslation(activity: TranslationActivity) {
    const urlBase = `${axios.defaults.baseURL}/jobs/${activity.jobId}/activities/${activity.id}/download`
    const downloadPath = this.hideStamp ? urlBase + '?unstamped=true' : urlBase
    downloadFile(downloadPath)
  }

  open(translation: TranslationActivity) {
    this.activity = translation
    this.show = true
  }

  close() {
    this.show = false
    this.activity = null
    this.hideStamp = false
  }
}
